import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-fidelite',
  templateUrl: './list-fidelite.component.html',
  styleUrls: ['./list-fidelite.component.scss']
})
export class ListFideliteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
